import { render, staticRenderFns } from "./coupon-info-card.vue?vue&type=template&id=5ecb052c&scoped=true&"
import script from "./coupon-info-card.vue?vue&type=script&lang=ts&"
export * from "./coupon-info-card.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-info-card.vue?vue&type=style&index=0&id=5ecb052c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb052c",
  null
  
)

export default component.exports